import * as React from 'react';
import { OffsiteCampaignEditorProvider } from '../context/UseOffsiteCampaignEditorContext';
import OffsiteCampaignEditor from './OffsiteCampaignEditor';

export const OffsiteCampaignEditorPage: React.FC = () => (
  <OffsiteCampaignEditorProvider>
    <OffsiteCampaignEditor />
  </OffsiteCampaignEditorProvider>
);

export default OffsiteCampaignEditorPage;
